const financialExchange = [
  {
    path: '/financial/exchanges',
    name: 'Exchanges',
    redirect: { name: 'OpenExchanges' },
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
    },
    component: () => import('@/_backoffice/_financial/components/exchange/Exchanges'),
    children: [
      {
        meta: {
          auth: true,
          roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
        },
        path: '/financial/exchanges/open',
        name: 'OpenExchanges',
        component: () => import('@/_backoffice/_financial/components/exchange/OpenExchanges'),
      },
    ]
  },
]

export default financialExchange
